const getRandomInt = (min: number, max: number) => {
  min = Math.ceil(min);
  max = Math.floor(max);

  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const addParameterToRelativeURL = (
  url: string,
  paramName: string,
  paramValue: string
) => {
  const hasQueryString = url.includes('?');
  const separator = hasQueryString ? '&' : '?';

  return `${url}${separator}${encodeURIComponent(
    paramName
  )}=${encodeURIComponent(paramValue)}`;
};

export const updateString = (
  str: string,
  textTransform: string = 'Capitalize'
) => {
  switch (textTransform) {
    case 'Uppercase':
      return str.toUpperCase();
    case 'Lowercase':
      return str.toLowerCase();
    case 'Capitalize':
      return str.replace(/^\w/, (c) => c.toUpperCase());
  }

  return str;
};

const defaultLocalizedStrings = {
  one_text: 'One',
  two_text: 'Two',
  three_text: 'Three',
  four_text: 'Four',
  five_text: 'Five',
  six_text: 'Six',
  seven_text: 'Seven',
  eight_text: 'Eight',
  nine_text: 'Nine',
  ten_text: 'Ten',
  multiplier_text: 'times',
};

export function createChallenge(
  {
    is_use_digits,
    maximum_multiplier,
  }: { is_use_digits: boolean; maximum_multiplier: number },
  localizedStrings: Record<string, any> & { [key: string]: string }
) {
  const maxValue = maximum_multiplier > 10 ? 10 : maximum_multiplier;

  const firstNum = getRandomInt(1, maxValue);
  const secondNum = getRandomInt(1, firstNum === 10 ? 9 : maxValue);

  let resultString = '';

  if (is_use_digits) {
    resultString = `${firstNum} x ${secondNum} = ?`;
  } else {
    const text_names = [
      'one_text',
      'two_text',
      'three_text',
      'four_text',
      'five_text',
      'six_text',
      'seven_text',
      'eight_text',
      'nine_text',
      'ten_text',
    ];
    const localizations: { [key: string]: string } = {
      ...defaultLocalizedStrings,
      ...localizedStrings,
    };

    resultString = `${localizations[text_names[firstNum - 1]]} ${
      localizations['multiplier_text']
    } ${localizations[text_names[secondNum - 1]]} = ?`;
  }

  resultString = updateString(resultString);
  const result = firstNum * secondNum;

  return { string: resultString, number: result };
}

/**
 * Safely parses and decodes a redirect URL parameter.
 */
export function parseRedirectUrl(redirectToParam: string): string {
  let decoded = redirectToParam;

  try {
    decoded = decodeURIComponent(redirectToParam);
  } catch {
    // Keep the original value when decoding fails.
  }

  try {
    const url = new URL(decoded);
    return url.pathname + url.search;
  } catch {
    return decoded;
  }
}
